// Widget host per environment.
// NOTE: local and test intentionally use staging-sync so the widget
// works against real (non-prod) publisher configs during development.
// When a dedicated testing-sync key/URL is confirmed, update local/test below.
const WIDGET_HOSTS = {
    local: '//testing-sync.ecal.com',
    test:  '//testing-sync.ecal.com',
    stage: '//staging-sync.ecal.com',
    prod:  '//sync.ecal.com',
};

// NOTE: the prod master API key is stored here. Confirm with the backend team
// whether staging-sync requires a different data-ecal-apikey value and update if so.
const WIDGET_API_KEY = 'ab1d23dbc0a6679e4f3c99b6fbf503f1601cd19cb9947';

function injectWidgetScript(env) {
    const host = WIDGET_HOSTS[env] || WIDGET_HOSTS.stage;
    const script = document.createElement('script');
    script.src = `${host}/v2/ecal.widget.min.js`;
    script.setAttribute('data-ecal-apikey', WIDGET_API_KEY);
    document.head.appendChild(script);
}

function initEnv() {
    const subdomain = window.location.hostname.split('.')[0];
    const regularDomains = ['localhost'];
    if (!regularDomains.includes(subdomain) && isNaN(Number(subdomain))) {
        this.subdomain = subdomain;
    }

    injectWidgetScript(window.env);
}

export default initEnv;
